import isEmail from 'validator/lib/isEmail';

export const INVALID_DOMAINS = [
  'al',
  'aool',
  'hotnail',
  'homail',
  'hotmaill',
  'gnail',
  'gmal',
  'gmaill',
  'yahooo',
  'yaho'
];
export const INVALID_EXTENSIONS = [
  'comm',
  'con',
  'ccom',
  'cmo',
  'cm',
  'co',
  'ed',
  'i'
];
export const VALID_PROVIDERS = [
  'aol.com',
  'gmail.com',
  'hotmail.com',
  'icloud.com',
  'outlook.com',
  'yahoo.com',
  'msn.com',
  'microsoft.com'
];

/**
 * @name emailValidation
 * @description We want to do our best to prevent basic typos to as our
 * users attempt to sign up and create their profile. Email validation is
 * actually incredibly complex, so instead we attempt to catch the common
 * issues we normally encounter, then fallback to a more generic validation
 */
export const emailValidation = (email = ''): boolean => {
  const value = email.toLowerCase();

  // These are required for any valid email
  if (!email.includes('@') || !email.includes('.') || email.includes('..'))
    return false;

  const [user, domain] = value.split('@');
  const parts = domain.split('.');
  const ext = parts.pop();

  // The easiest to validate
  if (VALID_PROVIDERS.includes(domain)) return true;

  // Common typos we can attempt to catch
  if (!ext) return false;
  if (user.length === 0) return false;
  if (INVALID_DOMAINS.includes(parts.join('.'))) return false;
  if (INVALID_EXTENSIONS.includes(ext)) return false;

  // Fallback to the validation package rules
  return isEmail(email);
};
